import CompanyPage from './classes/company-page';
import VideoNative from './components/video/native';

(function(window) {
  class Ecommerces extends CompanyPage {
    constructor() {
      super();

      this.startFluxogram();
      this.createVideoSection();
      this.createLogisticsVideo();
    }

    createLogisticsVideo() {
      if (!this.isMobileDevice) {
        VideoNative(
          window.document.querySelector(
            '#ecommerces-logistics .simple-content-image'
          )
        );
      }
    }
  }

  new Ecommerces(window);
})(window);
